/**
 * FreeRoundsData.ts
 */
export class FreeRoundsData {
    constructor() {
        this.freeRoundsEnabled = false;
    }
    setFreeRoundsEnabled(status) {
        this.freeRoundsEnabled = status;
    }
    isFreeRoundsEnabled() {
        return this.freeRoundsEnabled;
    }
    setDescription(description) {
        this.description = description;
    }
    getDescription() {
        return this.description;
    }
    setExpiryDate(date) {
        this.expiryDate = date;
    }
    getExpiryDate() {
        return this.expiryDate;
    }
    setID(id) {
        this.id = id;
    }
    getID() {
        return this.id;
    }
    setSiteID(siteID) {
        this.siteID = siteID;
    }
    getSiteID() {
        return this.siteID;
    }
    setName(name) {
        this.name = name;
    }
    getName() {
        return this.name;
    }
    setRounds(rounds) {
        this.rounds = rounds;
    }
    getRounds() {
        return this.rounds;
    }
    setRoundsRemaining(roundsRemaining) {
        this.roundsRemaining = roundsRemaining;
    }
    getRoundsRemaining() {
        return this.roundsRemaining;
    }
    setStake(stake) {
        this.stake = stake;
    }
    getStake() {
        return this.stake;
    }
    setUUID(uuid) {
        this.uuid = uuid;
    }
    getUUID() {
        return this.uuid;
    }
    getCampaignAccumulatedWins() {
        return this.campaignAccumulatedWins;
    }
    setCampaignAccumulatedWins(wins) {
        this.campaignAccumulatedWins = wins;
    }
}
//# sourceMappingURL=FreeRoundsData.js.map